// extracted by mini-css-extract-plugin
export default {"select":"styles_select__zXyDP","upload_result":"styles_upload_result__bTiMN"};